import useDocumentTitle from "../hooks/useDocumentTitle";

export default function Datenschutz() {
  useDocumentTitle("Datenschutz", "Datenschutzerklärung für Livinora Interior Concepts gemäß DSGVO.");
  return (
    <div data-testid="page-datenschutz" className="pt-32 md:pt-44 pb-24">
      <div className="container-livinora max-w-3xl">
        <span className="overline">Datenschutz</span>
        <h1 className="serif mt-8 text-5xl md:text-6xl leading-[1.02]">Datenschutzerklärung</h1>

        <div className="mt-12 space-y-10 leading-relaxed">
          <section>
            <h2 className="serif text-2xl mb-3">1. Verantwortlicher</h2>
            <p>
              Verantwortlicher im Sinne der DSGVO ist der im Impressum genannte Anbieter dieser
              Website.
            </p>
          </section>

          <section>
            <h2 className="serif text-2xl mb-3">2. Erhebung personenbezogener Daten</h2>
            <p className="text-[color:var(--livinora-muted)]">
              Wir erheben personenbezogene Daten ausschließlich im Rahmen Ihrer Anfrage über unser
              Kontaktformular oder den Konfigurator. Ihre Angaben werden zur Bearbeitung Ihrer
              Anfrage verwendet und nicht ohne Ihre Zustimmung an Dritte weitergegeben.
            </p>
          </section>

          <section>
            <h2 className="serif text-2xl mb-3">3. Speicherdauer</h2>
            <p className="text-[color:var(--livinora-muted)]">
              Anfragen werden so lange gespeichert, wie es für die Bearbeitung Ihres Anliegens
              erforderlich ist oder gesetzliche Aufbewahrungsfristen dies verlangen.
            </p>
          </section>

          <section>
            <h2 className="serif text-2xl mb-3">4. Ihre Rechte</h2>
            <p className="text-[color:var(--livinora-muted)]">
              Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der
              Verarbeitung und Datenübertragbarkeit. Zusätzlich haben Sie ein Beschwerderecht bei
              einer Aufsichtsbehörde.
            </p>
          </section>

          <section>
            <h2 className="serif text-2xl mb-3">5. Cookies & Analyse</h2>
            <p className="text-[color:var(--livinora-muted)]">
              Diese Website verwendet ausschließlich technisch notwendige Speichermechanismen (z. B.
              für die Speicherung Ihrer gewählten Ansicht). Es werden keine Analyse- oder
              Marketing-Cookies geladen.
            </p>
          </section>

          <section>
            <h2 className="serif text-2xl mb-3">6. Kontakt</h2>
            <p>
              Bei Fragen zum Datenschutz nutzen Sie bitte unser{" "}
              <a href="/kontakt" className="underline-offset-4 hover:underline text-[color:var(--livinora-ink)]">Kontaktformular</a>.
              Postadresse und Pflichtangaben des Verantwortlichen finden Sie im{" "}
              <a href="/impressum" className="underline-offset-4 hover:underline text-[color:var(--livinora-ink)]">Impressum</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
